export function truncate(text: string, length: number = 15): string {
    if (!text) return ''
    if (text.length <= length) return text
    return text.slice(0, length - 1) + '…'
}

export function capitalize(text: string): string {
    if (!text) return ''
    return text.charAt(0).toUpperCase() + text.slice(1)
}
